<script setup>
import { useAuthStore, useAssessmentsStore } from '../stores';
import AppLinkCard from '../components/layouts/AppLinkCard.vue';
import AppCard from '../components/layouts/AppCard.vue';
import { useRouter } from 'vue-router'
import { notify } from 'notiwind'
const authStore = useAuthStore();
const router = useRouter()

const goToReadiness = (childId) => {
    authStore.currentChildId = childId
    router.push('/readiness')
}
</script>
<template>
    <div class="mx-2">
        <div class="grid grid-cols-1 md:grid-cols-3 justify-center items-center content-start">            
            <AppLinkCard v-if="authStore.user && authStore.sortedChildren.length === 0"
            :header="`Welcome${authStore.user ? ' ' + authStore.user.first_name : ''}!`"
            :body="`You haven't added any kids. That might be a good place to start!`" to="/account/child/new" />
            <!-- <AppLinkCard :header="`Tita's Tips: The Importance of Language`"
                :body="`Did you know that children who lack vocabulary by the time they start kindergarten are less likely to succeed after?`"
                to="/tips/:id" /> -->
            <div v-for="child in authStore.sortedChildren" >
                <AppCard v-if="child.current_readiness_report_card" :header="`${child.first_name}'s Check-in`"
                    :body="`Let's pick up where ${child.first_name} left off`"
                    @clicked="goToReadiness(child.id)"  />
                <AppLinkCard v-else
                    to="/readiness" :header="`${child.first_name}'s Readiness`"
                    :body="`${child.first_name} can start a new readiness report card!`"
                    @clicked="goToReadiness(child.id)" />
            </div>     
        </div>
    </div>
</template>